// JobPostingv2 Events for Logging
// This file contains all event definitions for JobPostingv2 components

const JOB_POSTING_V2 = "JOB_POSTING_V2";

export const JOBPOSTING_V2_EVENTS = {
  // Unavailable City Request Events
  UNAVAILABLE_CITY_REQUEST: {
    name: "OTHER_CITY_REQUEST",
    category: JOB_POSTING_V2
  },

  // Job Benefits Events
  JOB_BENEFITS_SELECTED: {
    name: "JOB_BENEFITS_SELECTED",
    category: JOB_POSTING_V2
  },
  JOB_BENEFITS_DESELECTED: {
    name: "JOB_BENEFITS_DESELECTED",
    category: JOB_POSTING_V2
  },
  JOB_BENEFITS_CUSTOM_ADDED: {
    name: "JOB_BENEFITS_CUSTOM_ADDED",
    category: JOB_POSTING_V2
  },

  // Industry Events
  INDUSTRY_SELECTED: {
    name: "INDUSTRY_SELECTED",
    category: JOB_POSTING_V2
  },
  INDUSTRY_DESELECTED: {
    name: "INDUSTRY_DESELECTED",
    category: JOB_POSTING_V2
  },
  INDUSTRY_CUSTOM_ADDED: {
    name: "INDUSTRY_CUSTOM_ADDED",
    category: JOB_POSTING_V2
  },
  INDUSTRY_EXPERIENCE_TOGGLED: {
    name: "INDUSTRY_EXPERIENCE_TOGGLED",
    category: JOB_POSTING_V2
  },

  // Job Posting Stepper Events
  STEP_CLICKED: {
    name: "STEP_CLICKED",
    category: JOB_POSTING_V2
  },
  PREVIEW_OPENED: {
    name: "PREVIEW_OPENED",
    category: JOB_POSTING_V2
  },
  PREVIEW_CLOSED: {
    name: "PREVIEW_CLOSED",
    category: JOB_POSTING_V2
  },
  MOBILE_PREVIEW_OPENED: {
    name: "MOBILE_PREVIEW_OPENED",
    category: JOB_POSTING_V2
  },
  MOBILE_PREVIEW_CLOSED: {
    name: "MOBILE_PREVIEW_CLOSED",
    category: JOB_POSTING_V2
  },

  // Job Posting Form Events
  JOB_POST_OPENED:{
    name: "JOB_POST_OPENED",
    category: JOB_POSTING_V2
  },
  FORM_INITIALIZED: {
    name: "FORM_INITIALIZED",
    category: JOB_POSTING_V2
  },
  STEP_NAVIGATED: {
    name: "STEP_NAVIGATED",
    category: JOB_POSTING_V2
  },
  JOB_DATA_LOADED: {
    name: "JOB_DATA_LOADED",
    category: JOB_POSTING_V2
  },
  JOB_EDIT_DETECTION: {
    name: "JOB_EDIT_DETECTION",
    category: JOB_POSTING_V2
  },

  // Assets Component Events
  ASSET_SELECTED: {
    name: "ASSET_SELECTED",
    category: JOB_POSTING_V2
  },
  ASSET_DESELECTED: {
    name: "ASSET_DESELECTED",
    category: JOB_POSTING_V2
  },
  ASSETS_CARD_EXPANDED: {
    name: "ASSETS_CARD_EXPANDED",
    category: JOB_POSTING_V2
  },

  // Browser Back Confirm Dialog Events
  BROWSER_BACK_STAY: {
    name: "BROWSER_BACK_STAY",
    category: JOB_POSTING_V2
  },
  BROWSER_BACK_LEAVE: {
    name: "BROWSER_BACK_LEAVE",
    category: JOB_POSTING_V2
  },
  BROWSER_BACK_DIALOG_DISMISSED: {
    name: "BROWSER_BACK_DIALOG_DISMISSED",
    category: JOB_POSTING_V2
  },

  // Category Change Alert Events
  CATEGORY_CHANGE_ALERT_OPENED: {
    name: "CATEGORY_CHANGE_ALERT_OPENED",
    category: JOB_POSTING_V2
  },
  CATEGORY_CHANGE_CONFIRMED: {
    name: "CATEGORY_CHANGE_CONFIRMED",
    category: JOB_POSTING_V2
  },
  CATEGORY_CHANGE_CANCELLED: {
    name: "CATEGORY_CHANGE_CANCELLED",
    category: JOB_POSTING_V2
  },

  // Client Name Component Events
  CLIENT_NAME_SELECTED: {
    name: "CLIENT_NAME_SELECTED",
    category: JOB_POSTING_V2
  },
  CLIENT_NAME_SEARCHED: {
    name: "CLIENT_NAME_SEARCHED",
    category: JOB_POSTING_V2
  },
  CLIENT_CHIP_SELECTED: {
    name: "CLIENT_CHIP_SELECTED",
    category: JOB_POSTING_V2
  },

  // Communication Preference Events
  ALLOW_CALLS_TOGGLED: {
    name: "ALLOW_CALLS_TOGGLED",
    category: JOB_POSTING_V2
  },
  WHATSAPP_UPDATES_TOGGLED: {
    name: "WHATSAPP_UPDATES_TOGGLED",
    category: JOB_POSTING_V2
  },
  PHONE_EDIT_CLICKED: {
    name: "PHONE_EDIT_CLICKED",
    category: JOB_POSTING_V2
  },
  OTP_VERIFICATION_STARTED: {
    name: "OTP_VERIFICATION_STARTED",
    category: JOB_POSTING_V2
  },

  // Confirmation Events
  SECTION_EDITED: {
    name: "SECTION_EDITED",
    category: JOB_POSTING_V2
  },
  DESCRIPTION_EXPANDED: {
    name: "DESCRIPTION_EXPANDED",
    category: JOB_POSTING_V2
  },

  // Deposit Required Events
  DEPOSIT_REQUIRED_SELECTED: {
    name: "DEPOSIT_REQUIRED_SELECTED",
    category: JOB_POSTING_V2
  },
  DEPOSIT_AMOUNT_CHANGED: {
    name: "DEPOSIT_AMOUNT_CHANGED",
    category: JOB_POSTING_V2
  },
  DEPOSIT_REASON_SELECTED: {
    name: "DEPOSIT_REASON_SELECTED",
    category: JOB_POSTING_V2
  },
  DEPOSIT_TIME_SELECTED: {
    name: "DEPOSIT_TIME_SELECTED",
    category: JOB_POSTING_V2
  },

  // Distance Events
  DISTANCE_SELECTED: {
    name: "DISTANCE_SELECTED",
    category: JOB_POSTING_V2
  },

  // Documents Events
  DOCUMENT_SELECTED: {
    name: "DOCUMENT_SELECTED",
    category: JOB_POSTING_V2
  },
  DOCUMENT_DESELECTED: {
    name: "DOCUMENT_DESELECTED",
    category: JOB_POSTING_V2
  },
  DOCUMENTS_CARD_EXPANDED: {
    name: "DOCUMENTS_CARD_EXPANDED",
    category: JOB_POSTING_V2
  },

  // Draft Confirmation Events
  DRAFT_CONTINUED: {
    name: "DRAFT_CONTINUED",
    category: JOB_POSTING_V2
  },
  DRAFT_DISMISSED: {
    name: "DRAFT_DISMISSED",
    category: JOB_POSTING_V2
  },

  // English Fluency Events
  ENGLISH_FLUENCY_SELECTED: {
    name: "ENGLISH_FLUENCY_SELECTED",
    category: JOB_POSTING_V2
  },
  ENGLISH_FLUENCY_CARD_EXPANDED: {
    name: "ENGLISH_FLUENCY_CARD_EXPANDED",
    category: JOB_POSTING_V2
  },

  // Experience Events
  MIN_EXPERIENCE_CHANGED: {
    name: "MIN_EXPERIENCE_CHANGED",
    category: JOB_POSTING_V2
  },
  MAX_EXPERIENCE_CHANGED: {
    name: "MAX_EXPERIENCE_CHANGED",
    category: JOB_POSTING_V2
  },
  FRESHER_TOGGLED: {
    name: "FRESHER_TOGGLED",
    category: JOB_POSTING_V2
  },

  // Famous Location Events
  FAMOUS_CATEGORY_SELECTED: {
    name: "FAMOUS_CATEGORY_SELECTED",
    category: JOB_POSTING_V2
  },
  FAMOUS_LOCATION_SELECTED: {
    name: "FAMOUS_LOCATION_SELECTED",
    category: JOB_POSTING_V2
  },

  // Gender Events
  GENDER_SELECTED: {
    name: "GENDER_SELECTED",
    category: JOB_POSTING_V2
  },

  // Interview Address Events
  INTERVIEW_ADDRESS_CHANGED: {
    name: "INTERVIEW_ADDRESS_CHANGED",
    category: JOB_POSTING_V2
  },

  // Interview Type Events
  INTERVIEW_TYPE_SELECTED: {
    name: "INTERVIEW_TYPE_SELECTED",
    category: JOB_POSTING_V2
  },

  // Address Same As Company Events
  ADDRESS_SAME_SELECTED: {
    name: "ADDRESS_SAME_SELECTED",
    category: JOB_POSTING_V2
  },

  // Sticky Footer Events
  BACK_BUTTON_CLICKED: {
    name: "BACK_BUTTON_CLICKED",
    category: JOB_POSTING_V2
  },
  NEXT_BUTTON_CLICKED: {
    name: "NEXT_BUTTON_CLICKED",
    category: JOB_POSTING_V2
  },
  JOB_SUBMITTED: {
    name: "JOB_SUBMITTED",
    category: JOB_POSTING_V2
  },
  PREMIUM_POPUP_SHOWN: {
    name: "PREMIUM_POPUP_SHOWN",
    category: JOB_POSTING_V2
  },
  JOB_PLAN_NAVIGATION: {
    name: "JOB_PLAN_NAVIGATION",
    category: JOB_POSTING_V2
  },

  // Job Category Events
  JOB_CATEGORY_SELECTED: {
    name: "JOB_CATEGORY_SELECTED",
    category: JOB_POSTING_V2
  },

  // Job City Events  
  JOB_CITY_SELECTED: {
    name: "JOB_CITY_SELECTED",
    category: JOB_POSTING_V2
  },

  // Job Description Events
  JOB_DESCRIPTION_CHANGED: {
    name: "JOB_DESCRIPTION_CHANGED",
    category: JOB_POSTING_V2
  },
  JOB_DESCRIPTION_TEMPLATE_APPLIED: {
    name: "TEMPLATE_APPLIED",
    category: JOB_POSTING_V2
  },

  // Job Locality Events
  JOB_LOCALITY_SELECTED: {
    name: "JOB_LOCALITY_SELECTED",
    category: JOB_POSTING_V2
  },

  // Job Timings Events
  JOB_TIMINGS_CHANGED: {
    name: "JOB_TIMINGS_CHANGED",
    category: JOB_POSTING_V2
  },

  // Job Title Events
  JOB_TITLE_SELECTED: {
    name: "JOB_TITLE_SELECTED",
    category: JOB_POSTING_V2
  },
  JOB_TITLE_TYPED: {
    name: "JOB_TITLE_TYPED",
    category: JOB_POSTING_V2
  },

  // Job Type Events
  JOB_TYPE_SELECTED: {
    name: "JOB_TYPE_SELECTED",
    category: JOB_POSTING_V2
  },
  IS_CONTRACTUAL_TOGGLED: {
    name: "CONTRACTUAL_TOGGLED",
    category: JOB_POSTING_V2
  },

  // Qualification Events
  QUALIFICATION_SELECTED: {
    name: "QUALIFICATION_SELECTED",
    category: JOB_POSTING_V2
  },

  // Regional Languages Events
  REGIONAL_LANGUAGE_SELECTED: {
    name: "REGIONAL_LANGUAGE_SELECTED",
    category: JOB_POSTING_V2
  },
  REGIONAL_LANGUAGE_DESELECTED: {
    name: "REGIONAL_LANGUAGE_DESELECTED",
    category: JOB_POSTING_V2
  },
  REGIONAL_LANGUAGES_CARD_EXPANDED: {
    name: "REGIONAL_LANGUAGES_CARD_EXPANDED",
    category: JOB_POSTING_V2
  },

  // Salary Events
  SALARY_CHANGED: {
    name: "SALARY_CHANGED",
    category: JOB_POSTING_V2
  },
  ADD_INCENTIVE_BUTTON_CLICKED: {
    name: "ADD_INCENTIVE_BUTTON_CLICKED",
    category: JOB_POSTING_V2
  },
  INCENTIVE_CHANGED: {
    name: "INCENTIVE_CHANGED",
    category: JOB_POSTING_V2
  },
  TARGET_BASED_TOGGLED: {
    name: "TARGET_BASED_TOGGLED",
    category: JOB_POSTING_V2
  },
  PER_PACKET_TOGGLED: {
    name: "PER_PACKET_TOGGLED",
    category: JOB_POSTING_V2
  },

  // Shift Type Events
  SHIFT_TYPE_SELECTED: {
    name: "SHIFT_TYPE_SELECTED",
    category: JOB_POSTING_V2
  },

  // Skills Events  
  SKILL_SELECTED: {
    name: "SKILL_SELECTED",
    category: JOB_POSTING_V2
  },
  SKILL_DESELECTED: {
    name: "SKILL_DESELECTED",
    category: JOB_POSTING_V2
  },
  CUSTOM_SKILL_ADDED: {
    name: "CUSTOM_SKILL_ADDED",
    category: JOB_POSTING_V2
  },

  // Vacancy Events
  VACANCY_CHANGED: {
    name: "VACANCY_CHANGED",
    category: JOB_POSTING_V2
  },
  VACANCY_CHIP_SELECTED: {
    name: "VACANCY_CHIP_SELECTED",
    category: JOB_POSTING_V2
  },
  VACANCY_CHANGED_INCREMENT_BUTTON_CLICKED: {
    name: "VACANCY_CHANGED_INCREMENT_BUTTON_CLICKED",
    category: JOB_POSTING_V2
  },
  VACANCY_CHANGED_DECREMENT_BUTTON_CLICKED: {
    name: "VACANCY_CHANGED_DECREMENT_BUTTON_CLICKED",
    category: JOB_POSTING_V2
  },

  // Working Days Events
  WORKING_DAYS_SELECTED: {
    name: "WORKING_DAYS_SELECTED",
    category: JOB_POSTING_V2
  },
  CUSTOM_WORKING_DAYS_ADDED: {
    name: "CUSTOM_WORKING_DAYS_ADDED",
    category: JOB_POSTING_V2
  },

  // Work Location Events
  WORK_LOCATION_SELECTED: {
    name: "WORK_LOCATION_SELECTED",
    category: JOB_POSTING_V2
  },

  // 

  // Future events can be added here
  // JOB_POSTING_STARTED: {
  //   name: "job_posting_started",
  //   category: JOB_POSTING_V2
  // },
  // JOB_POSTING_COMPLETED: {
  //   name: "job_posting_completed",
  //   category: JOB_POSTING_V2
  // }
};
